'use client';
import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

export function useGoogleAnalytics() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (typeof window.gtag === 'undefined') return;

    const search = searchParams.toString();
    const page_path = pathname + (search ? `?${search}` : '');
    const page_location = window.location.href;
    const page_title = document.title;

    // Send custom page_view event
    window.gtag('event', 'page_view', {
      page_location,
      page_path,
      page_title,
    });

    // Dev-only console log
    if (process.env.NODE_ENV !== 'production') {
      console.log('[GA] page_view', page_path);
    }
  }, [pathname, searchParams]);
}

export function trackEvent(eventName: string, eventParams: Record<string, any> = {}) {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, eventParams);
  }
}

// Conversion tracking for contact form submissions
export function trackConversion(conversionData: {
  service?: string;
  budget?: string;
  value?: number;
  currency?: string;
}) {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      send_to: 'G-ZWDVXCQWB9',
      event_category: 'Contact Form',
      event_label: conversionData.service || 'General Inquiry',
      value: conversionData.value || 0,
      currency: conversionData.currency || 'EUR',
      ...conversionData,
    });
  }
}

// Track funnel stages
export function trackFunnelStage(stage: string, data: Record<string, any> = {}) {
  trackEvent('funnel_stage', {
    funnel_stage: stage,
    ...data,
  });
}

// Track visitor behavior
export function trackBehavior(action: string, data: Record<string, any> = {}) {
  trackEvent('user_behavior', {
    behavior_action: action,
    ...data,
  });
}